import AnalysisPanel from "./AnalysisPanel";

export default AnalysisPanel;
